/*
  convert the data object to dto. 注意，这个模块只做 transfer
 */
import env from "../../config/env";
import util from "util";
import HRN from "human-readable-numbers";
import {EntityType, DateFormat} from "../utils";
var {DateUtils} = require('@shangyang/utils');

export class Entity{

    /**
     * 因为现在是每次分页的时候才会转换，因此
     * @param {Array} entities
     */
    static convertEntities(entities){
        for(let e of entities){
            this.convertEntity(e)  // 引用传递，因此直接修改即可。
        }
        return entities;
    }

    /**
     * <img src="http://47.242.80.92/e/iip2BFAWcpP/2552591082052653535_1.jpg " />
     * @param e, the source popupingEntity
     */
    static convertEntity(e){
        // first convert the image/video path and the thumbnail path
        for(let s of e.public_slots){
            s.pic = Entity.getPublicResPath(e.shortcode, s.pic);
            if(!util.isNullOrUndefined(s.video))
                s.video = Entity.getPublicResPath(e.shortcode, s.video);
        }
        e.thumbnail = Entity.getPublicResPath(e.shortcode, e.thumbnail);
        // second, convert likes and favorites to be Human Readable String...
        e.likes_hrn = HRN.toHumanString(e.likes)
        e.favorites_hrn = HRN.toHumanString(e.favorites)
        // third, conver the public_slots to be slots
        e.slots = e.public_slots;
        e.upload_ts = DateFormat.stdFormat(e.upload_ts);
        delete e.public_slots;
        return e;
    }

    static getPublicResPath(shortcode, name){
        return `${env.IMAGE_BASE_URL()}/e/${shortcode}/${name}`;
    }

}

export class Profile{

    /**
     * @param {object} p
     */
    static convertProfile(p){
        // let _p = _.cloneDeep(p);
        p.avatar = `${env.IMAGE_BASE_URL()}/${p.avatar}`;
        return p;
    }

    /**
     * @param {Array<String>} profiles
     * @return {[]}
     */
    static convertProfiles(profiles){
        let converts = []
        for(let p of profiles){
            converts.push(Profile.convertProfile(p));
        }
        return converts;
    }

}

export class User{
    static convertUser(u){
        u.create_ts = DateFormat.stdFormat(u.create_ts);
        return u;
    }
}

export class Comment{

    static convertComments(comments){
        let arr = [];
        for(let c of comments){
            arr.push(this.convertComment(c));
        }
        return arr;
    }

    static convertComment(c){
        c.content = c.text;
        delete c.text;
        // first leve id transfer to root field already done via server side.
        c.root = c.first_level_id;
        delete c.first_level_id;
        // console.log('c.audit_ts', c.audit_ts, 'type', typeof(c.audit_ts), 'getFullYear', new Date(c.audit_ts).getFullYear());
        // c.audit_ts = SDF.formatWith(DATE_FORMATE_TEMPLATE, new Date(c.audit_ts));
        c.create_ts = DateFormat.simYearStdFormat(c.create_ts);
        return c;
    }
}

export class Deal{

    static convertDeals(deals){
        let deals_ = []
        for (let d of deals){
            deals_.push(Deal.convertDeal(d));
        }
        return deals_
    }

    static convertDeal(deal){
        deal.thumbnail = Entity.getPublicResPath(deal.shortcode, deal.thumbnail);
        deal.typeDesc = deal.type_desc; delete deal.type_desc;
        deal.creatTs = deal.create_ts; delete deal.create_ts;
        deal.downloadValidTo = deal.download_valid_to; delete deal.download_valid_to;
        // 因为后台的到期时间是调拨到了次日凌晨 0 点 0 分，便于程序上的判断，但是展示的时候需要回拨 1 天回来。
        deal.validTo = DateUtils.addDays(deal.downloadValidTo, -1);
        return deal
    }
}



// WEBPACK FOOTER //
// ./src/data/converter.js